import Title from "common/Typography/Title";
import PriceChange from "common/Charts/PriceChange";
import React, { useContext } from "react";
import { ICON_TYPES } from "@shared/common/constants";
import TextWithPrecisionAndIcon from "common/Text/TextWithPrecisionAndIcon";
import { DISPLAY_CURRENCIES } from "common/constants";
import { useSelector } from "react-redux";
import { TradeData } from "@shared/types";
import { selectDisplayCurrency } from "@shared/slices/common.slice";
import { usePrecisions } from "@shared/utils/hooks/usePrecisions";
import { SocketPnlContext } from "@shared/features/dashboard/SocketPnl.context";
import Flex from "common/Boxes/Flex";
import { SocketPnlResponse } from "@shared/services/socket/types";

interface PnlComponentProps {
  tradeData: TradeData;
  fontSize?: number;
  changeFontSize?: number;
  socketPnl?: SocketPnlResponse | undefined;
}

const PnlComponent = ({
  tradeData,
  fontSize,
  changeFontSize,
  socketPnl: propsSocketPnl,
}: PnlComponentProps) => {
  const { socketPnlValue } = useContext(SocketPnlContext) || {};
  const displayCurrency = useSelector(selectDisplayCurrency);
  const isBtc = displayCurrency === DISPLAY_CURRENCIES.BTC;
  const { getDisplayCurrencyAmountPrecision } = usePrecisions();
  const pnlData = propsSocketPnl || socketPnlValue?.[tradeData.id] || tradeData;

  return (
    <Flex>
      <Title style={{ marginRight: 4, fontSize }}>
        <TextWithPrecisionAndIcon
          text={isBtc ? pnlData.btc_amount_change : pnlData.usd_amount_change}
          precision={getDisplayCurrencyAmountPrecision()}
          iconType={ICON_TYPES.DISPLAY_CURRENCY}
          iconStyle={isBtc ? { fontSize: 12, marginBottom: 2 } : undefined}
        />
      </Title>
      <PriceChange
        change={
          pnlData?.graph_data && "profit" in pnlData?.graph_data
            ? pnlData?.graph_data.profit
            : 0
        }
        size={changeFontSize ?? 10}
        useBackground={true}
      />
    </Flex>
  );
};

export default PnlComponent;
